import { getCheckboxStyles } from './variantStyles/checkbox';
import { getCustomStyles } from './variantStyles/custom';
import { getCustomCheckboxStyles } from './variantStyles/customCheckbox';
import { getCustomRadioStyles } from './variantStyles/customRadio';
import { getRegularStyles } from './variantStyles/regular';
import { getToggleStyles } from './variantStyles/toggle';
import { getToggleTitleDescriptionStyles } from './variantStyles/toggleTitleDescription';
import { getUserStyles } from './variantStyles/user';
export const getSelectorRowStyles = (FOUNDATIONS, FONT) => ({
    ...getRegularStyles(FOUNDATIONS, FONT),
    ...getUserStyles(FOUNDATIONS, FONT),
    ...getCustomStyles(FOUNDATIONS, FONT),
    ...getCustomRadioStyles(FOUNDATIONS, FONT),
    ...getCustomCheckboxStyles(FOUNDATIONS, FONT),
    ...getToggleTitleDescriptionStyles(FOUNDATIONS, FONT),
    ...getToggleStyles(FOUNDATIONS, FONT),
    ...getCheckboxStyles(FOUNDATIONS, FONT),
});
//# sourceMappingURL=styles.js.map